export default {
  footer_description: '开云体育是专业体育赛事平台，提供足球、篮球、网球等多项体育赛事实时资讯、赛程直播与竞技数据分析。汇聚全球顶级联赛，为体育爱好者提供一站式体育娱乐体验。',
  footer_categories: '赛事分类',
  footer_quick_links: '快速链接',
  footer_contact: '联系我们',
  footer_about: '关于我们',
  footer_privacy: '隐私政策',
  footer_terms: '服务条款',
  footer_copyright: '© 2024 开云体育 版权所有',
  footer_email: 'service@kaiyunsports.com',
  footer_phone: '400-888-9999',
  footer_address: '服务时间：周一至周日 9:00 - 21:00',
}